export enum MarketplaceType {
    AMAZON = 1,
  }